/* eslint-disable react/no-unused-class-component-methods */
import React from "react";
import { Responsive, WidthProvider } from "react-grid-layout";
import PropTypes from "prop-types";

import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import "./DashboardGrid.scss";
import { updateSettings } from "api";
import errorToast from "helpers/errorToast";
import ResizeHandle from "./ResizeHandle";

const ResponsiveGridLayout = WidthProvider(Responsive);
const originalLayouts = {};

/**
 * A draggable, resizable Grid Layout.
 */
export class DashboardGrid extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      layouts: JSON.parse(JSON.stringify(originalLayouts)),
    };
    this.gridRef = React.createRef();
    this.widthUpdated = false;
  }

  componentDidUpdate(prevProps) {
    const { isSidebarShrink } = this.props;
    if (prevProps.isSidebarShrink !== isSidebarShrink) {
      if (this.gridRef?.current?.onWindowResize) {
        setTimeout(() => {
          this.gridRef?.current?.onWindowResize();
        }, 150);
      }
    }
  }

  onLayoutChange(layout, layouts) {
    const { widgets, isLayoutLocked } = this.props;
    let updatedLayouts = layouts;
    if (!this.widthUpdated) {
      const mapWidget = widgets.find((item) => item.type === "Map");
      if (layouts.md && mapWidget) {
        updatedLayouts = {
          ...layouts,
          md: layouts.md.map((item) => {
            if (item.i === mapWidget.id.toString()) {
              return {
                ...item,
                w: 3,
              };
            }
            return item;
          }),
        };
        this.widthUpdated = true;
      }
    }
    if (widgets.length !== 0 && !isLayoutLocked) {
      widgets.forEach((item, i) => {
        item.position = layout[i];
      });
      updateSettings({
        dashboard_widgets: widgets,
      }).catch((err) => errorToast(err, "Could not update widget settings. Please try again later."));
    }

    this.setState({ layouts: updatedLayouts });
  }

  resetLayout() {
    this.setState({ layouts: {} });
  }

  render() {
    const { layouts } = this.state;
    const { children, isLayoutLocked } = this.props;
    return (
      <ResponsiveGridLayout
        ref={this.gridRef}
        className="layout"
        breakpoints={{ xl: 2300, lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
        cols={{ xl: 6, lg: 5, md: 4, sm: 3, xs: 2, xxs: 1 }}
        rowHeight={30}
        margin={[25, 25]}
        resizeHandle={<ResizeHandle />}
        isBounded
        isDraggable={!isLayoutLocked}
        isResizable={!isLayoutLocked}
        layouts={layouts}
        onLayoutChange={(layout, layouts) => this.onLayoutChange(layout, layouts)}
        style={{ margin: -25 }}
      >
        {children}
      </ResponsiveGridLayout>
    );
  }
}

DashboardGrid.propTypes = {
  children: PropTypes.node,
  isLayoutLocked: PropTypes.bool.isRequired,
  widgets: PropTypes.instanceOf(Array).isRequired,
  isSidebarShrink: PropTypes.bool,
};

DashboardGrid.defaultProps = {
  children: null,
  isSidebarShrink: false,
};

export default DashboardGrid;
